import { BaseQuestionType } from "../BaseQuestionType";
import FreeTextQuestionOption from "./FreeTextQuestionOption";
import MultiChoiceQuestionOptions from "./MultipleChoiceQuestionOptions";
import MultipleSelectQuestionOptions from "./MultipleSelectQuestionOptions";
import NpsQuestionOptions, { NpsQuestionPrompt } from "./NPSQuestionOptions";

export default function QuestionOption({
    questionId,
    disabled,
    questionType,
    hideScore = false,
    canReviewResults = false,
}: {
    questionId: string;
    disabled: boolean;
    questionType?: string;
    hideScore?: boolean;
    canReviewResults?: boolean;
}) {
    const getQuestionOption = (() => {
        switch (questionType ?? "") {
            case BaseQuestionType.MultipleChoiceQuestion:
                return (
                    <MultiChoiceQuestionOptions
                        questionId={questionId}
                        disabled={disabled}
                        hideScore={hideScore}
                        canReviewResults={canReviewResults}
                    />
                );
            case BaseQuestionType.MultipleSelectQuestion:
                return (
                    <MultipleSelectQuestionOptions
                        questionId={questionId}
                        disabled={disabled}
                        hideScore={hideScore}
                    />
                );
            case BaseQuestionType.FreeTextQuestion:
                return (
                    <FreeTextQuestionOption
                        questionId={questionId}
                        disabled={disabled}
                    />
                );
            case BaseQuestionType.NpsQuestion:
                return (
                    <>
                        <NpsQuestionOptions
                            questionId={questionId}
                            disabled={disabled}
                        />
                        <NpsQuestionPrompt
                            questionId={questionId}
                            readOnlyMode={disabled}
                        />
                    </>
                );
        }
    })();

    return <>{getQuestionOption}</>;
}
